import { useTranslation } from 'react-i18next';

import { CONFIG } from 'src/config-global';
import type { ServiceNamespace } from 'src/locales/langs';
import type { JsonLdDocument } from 'src/types/json-ld';

export function useServiceStructuredData(
  namespace: ServiceNamespace,
  path: string
): JsonLdDocument[] {
  const { t } = useTranslation(namespace);
  const { t: tCommon } = useTranslation('common');

  const url = `${CONFIG.siteUrl}${path}`;

  const service: JsonLdDocument = {
    url,
    areaServed: 'PL',
    '@type': 'Service',
    name: t('service.name'),
    '@context': 'https://schema.org',
    description: t('service.description'),
    provider: {
      '@type': 'Organization',
      name: 'Somnus Sp. z o.o.',
      url: `${CONFIG.siteUrl}/`,
    },
  };

  const breadcrumbs: JsonLdDocument = {
    '@type': 'BreadcrumbList',
    '@context': 'https://schema.org',
    itemListElement: [
      {
        position: 1,
        '@type': 'ListItem',
        item: `${CONFIG.siteUrl}/`,
        name: tCommon('labels.home'),
      },
      {
        item: url,
        position: 2,
        '@type': 'ListItem',
        name: t('hero.breadcrumb'),
      },
    ],
  };

  return [service, breadcrumbs];
}
